export default "__VITE_ASSET__DlX_Ckf8__"